module.exports = __webpack_public_path__ + "c45a8709259b4c5af7df57da0749df66.MP3";